'use client';

import { useIsMobile } from '@/app/hooks/use-is-mobile';

type Props = {
  mobile: React.ReactNode;
  desktop: React.ReactNode;
  defaultIsMobile?: boolean;
};

export default function ResponsiveSection({
  mobile,
  desktop,
  defaultIsMobile = false,
}: Props) {
  const isMobile = useIsMobile(defaultIsMobile);
  return <>{isMobile ? mobile : desktop}</>;
}
